import React from 'react';
import GenerateReportModal from '../../generics/components/GenerateReportModal';
import { useEmployees } from '../EmployessContext';

// export default function GenerateEmployeesReportModal() {
//   const { rows } = useEmployees();
//   const [open, setOpen] = useState(false);

//   return <Box
//     sx={{ p: 3, width: '100%',
//       display: 'flex',
//       flexDirection: 'row' }}>
//     <Button fullWidth variant = "contained" onClick={() => setOpen(true)}>Generuj Raport</Button>
//     {open ? <GenerateReportModal handleClose={() => setOpen(false)} idList={rows.map(item => item.id)} getFields={getEmployeeFields} downloadSpreadsheet={downloadEmployeeSpreadsheet} /> : null}
//   </Box>;
// }


import { useQuery, useMutation } from 'react-fetching-library';
import { Box, Button, Divider, Menu, MenuItem, IconButton, CircularProgress, ListItem,
  ListItemIcon, ListItemButton, ListItemText, IconButtonCircularProgress, ListItemSecondaryAction } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Iconify from '../../../../components/Iconify';
import { getEmployeeFields, downloadEmployeeSpreadsheet, getEmployeeApplicationFields, downloadEmployeeApplicationSpreadsheet, getReviewReport, getSpreadsheetTemplates, deleteSpreadsheetTemplateAction } from '../../../../services/request';
import toast from 'react-hot-toast';
import { Add, Delete, Edit } from '@mui/icons-material';
import CreateSpreadsheetTemplateModal from '../../order/CreateSpreadsheetTemplateModal';
import EditSpreadsheetTemplateModal from '../../order/EditSpreadsheetTemplateModal';


export default function GenerateEmployeesReportModal() {
  const { mutate } = useMutation(downloadEmployeeSpreadsheet);
  const { mutate: deleteMutate } = useMutation(deleteSpreadsheetTemplateAction);
  const { mutate: bonusMutate, loading: bonusLoading } = useMutation(getReviewReport);
  const { loading, payload, error } = useQuery(getSpreadsheetTemplates('employees'));
  const { rows } = useEmployees();
  const idList = rows.map(item => item.id);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [openAddTemplateModal, setOpenAddTemplateModal] = React.useState(false);
  const [templates, setTemplates] = React.useState([]);
  const [templateId, setTemplateId] = React.useState(0);
  const [openEditModal, setOpenEditModal] = React.useState(false);

  const tab = 'employees';


  const handleOpenAddTemplateModal = () => {
    setOpenAddTemplateModal(true);
    handleClose();
  };


  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleDownload = async (id, name) => {
    const { error: mutateError, payload: mutatePayload } = await mutate({ id, 'id_list': idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `${name}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadReviewReport = async () => {
    const { error: mutateError, payload: mutatePayload } = await bonusMutate({ 'id_list': idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport bonusów.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleOpenEditModal = id => {
    setOpenEditModal(true);
    setTemplateId(id);
    handleClose();
  };

  const handleDelete = async id => {
    const { error: mutateError, payload: mutatePayload } = await deleteMutate(id);
    if (!mutateError) {
      setTemplates(prev => prev.filter(template => template.id !== id));
      toast.success('Szablon został usunięty');
    } else {
      toast.error('Nie udało się usunąć');
    }
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setTemplates(payload.results);
    }
  }, [loading]);

  return (
    <>
      <Box sx={{ p: 3, width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          fullWidth
          endIcon={<Iconify icon={'ri:file-excel-2-fill'}/>}
          onClick={handleClick}
        >
          Wygeneruj raport
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button'
          }}
          style={{ maxHeight: '60vh' }}
        >
          <MenuItem onClick={ () => setOpenModal(true)}>
            <ListItemIcon>
              <Iconify icon={'mingcute:file-line'} width={20} height={20} />
            </ListItemIcon>
            <ListItemText>
              Raport ręczny
            </ListItemText>
          </MenuItem>
          <MenuItem onClick={handleDownloadReviewReport} disabled={bonusLoading}>
            <ListItemIcon>
              {bonusLoading ? <CircularProgress size={20}/> : <FileDownloadIcon />}
            </ListItemIcon>
            <ListItemText>
              Opinie kadry
            </ListItemText>
          </MenuItem>

          <MenuItem onClick={handleOpenAddTemplateModal}>
            <ListItemIcon>
              <Add />
            </ListItemIcon>
            <ListItemText>
              Nowy szablon
            </ListItemText>
          </MenuItem>

          <Divider>Szablony</Divider>
          {templates.map(template => (
            <ListItem
              key={template.id}
              sx={{ pr: '96px' }}
              disablePadding
            >
              <ListItemButton role={undefined} onClick={() => handleDownload(template.id, template.template_name)}>
                <ListItemIcon>
                  <FileDownloadIcon />
                </ListItemIcon>
                <ListItemText>
                  {template.template_name}
                </ListItemText>
              </ListItemButton>
              <ListItemSecondaryAction sx={{ width: '96px', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                <IconButton edge="end" aria-label="comments" onClick={() => handleOpenEditModal(template.id)}>
                  <Edit color="primary"/>
                </IconButton>
                <IconButton edge="end" aria-label="comments" onClick={() => handleDelete(template.id)}>
                  <Delete color="error"/>
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}

        </Menu>
      </Box>
      {openModal ? <GenerateReportModal handleClose={() => setOpenModal(false)} idList={rows.map(item => item.id)} getFields={getEmployeeFields} downloadSpreadsheet={downloadEmployeeSpreadsheet} /> : null}
      {openAddTemplateModal ? <CreateSpreadsheetTemplateModal open={openAddTemplateModal} handleClose={() => setOpenAddTemplateModal(false)} setTemplates={setTemplates} tab={tab}/> : null}
      {openEditModal ? <EditSpreadsheetTemplateModal open={openEditModal} handleClose={() => setOpenEditModal(false)} templateId={templateId} tab={tab}/> : null}
    </>
  );
}
